var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.046 5.037c.497-2.05 3.411-2.05 3.908 0a2.01 2.01 0 003.002 1.243c1.8-1.096 3.862.964 2.765 2.765a2.013 2.013 0 001.242 3c2.05.498 2.05 3.412 0 3.91a2.01 2.01 0 00-1.243 3.001c1.097 1.8-.964 3.862-2.765 2.765a2.012 2.012 0 00-3 1.242c-.498 2.05-3.412 2.05-3.91 0a2.01 2.01 0 00-3.001-1.243c-1.8 1.097-3.862-.964-2.765-2.765a2.01 2.01 0 00-1.242-3c-2.05-.498-2.05-3.412 0-3.91A2.01 2.01 0 006.28 9.045c-1.096-1.8.964-3.862 2.765-2.765a2.01 2.01 0 003-1.242z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0v0z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/cog.19956718.svg";
export { SvgCog as ReactComponent };